// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'wallet';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinejoin='round'>
    <g strokeLinecap='round'>
      <path d='M15.906 13.604v1.063a2.125 2.125 0 0 1-2.125 2.125H3.156a2.125 2.125 0 0 1-2.125-2.125V7.229a2.125 2.125 0 0 1 2.125-2.125h10.625a2.125 2.125 0 0 1 2.125 2.125v1.063m-2.125-3.188-1.65-3.3a1.062 1.062 0 0 0-1.425-.475l-7.55 3.775' />
      <path d='M15.906 13.604a1.063 1.063 0 0 0 1.063-1.062V9.354a1.063 1.063 0 0 0-1.063-1.062H13.25a2.657 2.657 0 0 0 0 5.312z' />
    </g>
    <path d='M13.25 11.213a.266.266 0 1 1 0-.53m0 .53a.266.266 0 1 0 0-.53' />
  </g>
);

export const viewBox = '0 0 18 18';
